export function sortObject(obj) {
    const array = [];

    for (const property in obj) {
        if (Object.hasOwn(obj, property)) {
            array.push({
                siglaMagistrado: property,
                antiguidade: obj[property]
            });
        }
    }

    array.sort(function (a, b) {
        return a.antiguidade - b.antiguidade;
    });

    return array;
}

export function montarNomeComTratamento(magistrado, salaSessaoStore) {
    return salaSessaoStore.pronomeTratamentoComCargo(magistrado) + ' ' + magistrado.nome.trim();
}

export function removerAusenciaMagistrados(textoBase, nomesPresentes, salaSessaoStore) {
    if (!textoBase || nomesPresentes.length === 0) {
        return textoBase;
    }

    const regex = /\n?Observação (\d+): (ausentes?), justificadamente, ([^\n]*?)\.(?=\n|$)/g;

    const novoTexto = textoBase.replaceAll(regex, (match, numero, _prefixo, lista) => {
        const nomes = lista.replace(/ e (?!.* e )/, ', ').split(', ');
        const restantes = nomes.filter((nome) => !nomesPresentes.includes(nome));

        if (restantes.length === nomes.length) {
            return match;
        }
        if (restantes.length === 0) {
            return '';
        }

        const inicio = match.startsWith('\n') ? '\n' : '';
        const prefixo = restantes.length > 1 ? 'ausentes' : 'ausente';
        const listaNova =
            restantes.length > 1 ? restantes.slice(0, -1).join(', ') + ' e ' + restantes.at(-1) : restantes[0];

        return `${inicio}Observação ${numero}: ${prefixo}, justificadamente, ${listaNova}.`;
    });

    return novoTexto === textoBase ? textoBase : salaSessaoStore.renumerarObservacoes(novoTexto);
}

export async function obterDecisaoCertidao(registro, sessaoStore, certidaoService) {
    const sessaoSelecionada = sessaoStore.sessaoSelecionada;
    const sessaoRegistro =
        sessaoStore.sessoesSessaoSelecionada?.find((s) => s.id === registro.sessaoId) || sessaoSelecionada;

    const certidaoJSON = await certidaoService.recuperarCamposCertidao(
        registro,
        sessaoSelecionada.orgaoJudicante.sigla,
        sessaoSelecionada.orgaoJudicante.descricao,
        sessaoRegistro.tipoJulgamento ?? sessaoSelecionada.tipoJulgamento
    );

    return certidaoJSON?.decisao || '';
}

export function getEntradaDominioAtual(magistrado, dominioStore) {
    return dominioStore.getEntradaDominioMagistrado(magistrado);
}

export function variantePosterior(entradaAtual, dominioStore) {
    if (!entradaAtual) return null;

    const variantes = dominioStore.getVariantesSiglaMagistrado(entradaAtual);

    if (variantes.length < 2) return null;

    const siglasAdm = new Set(variantes.map((v) => v.siglaAdministrativa));

    if (siglasAdm.size < 2) return null;

    const indice = variantes.findIndex((v) => v.siglaAdministrativa === entradaAtual.siglaAdministrativa);
    return variantes[(Math.max(indice, 0) + 1) % variantes.length];
}

export function isMagistradoSubstitutoDefinido(magistrado) {
    return Boolean(magistrado?.magistradoSubstituto?.sigla && magistrado.magistradoSubstituto.sigla.length > 0);
}

export function isMagistradoSubstituidoDefinido(magistrado) {
    return Boolean(magistrado?.magistradoSubstituido?.sigla && magistrado.magistradoSubstituido.sigla.length > 0);
}

export function localizacaoUsuario(usuarioStore) {
    return usuarioStore.usuario?.localizacao;
}

export function defineTitle(roles, title, magistrado, defineRedatorRelator, getProcessosRelator) {
    const genero = magistrado.genero === 'M' ? '' : 'a';

    const processos = typeof getProcessosRelator === 'function' ? getProcessosRelator(magistrado) || [] : [];
    const numerosProcessosRelator = processos.map((r) => r.processo?.numeroCompleto || r.processo || r);
    let numerosParaExibir;

    if (numerosProcessosRelator.length > 20) {
        numerosParaExibir = numerosProcessosRelator.slice(0, 20);
    }

    if (numerosProcessosRelator.length > 0) {
        const complemento = numerosProcessosRelator.length === 1 ? 'no processo' : 'nos processos';

        title =
            `${magistrado.nome}\n` +
            `Relator${genero} ${complemento}: ${numerosParaExibir ? numerosParaExibir.join('; ') + '...' : numerosProcessosRelator.join('; ')}`;

        return title;
    }

    title =
        roles.redator && roles.relator
            ? `Redator${genero} e Relator${genero} ` + magistrado.nome
            : // eslint-disable-next-line sonarjs/no-nested-conditional
              defineRedatorRelator
              ? defineRedatorRelator(roles, title, magistrado)
              : title;

    return title;
}

export function tooltipSubstituicao(magistrado) {
    if (isMagistradoSubstitutoDefinido(magistrado)) {
        return `Substituído por ${magistrado.magistradoSubstituto.nome} (${magistrado.magistradoSubstituto.sigla})`;
    }
    if (magistrado.magistradoSubstituido) {
        return `Substituindo ${magistrado.magistradoSubstituido.nome} (${magistrado.magistradoSubstituido.sigla})`;
    }
}

export function shouldEsconderComboSubstituto(magistrado) {
    return (!magistrado.ausente && !magistrado.situacaoImpedimento) || isMagistradoSubstituidoDefinido(magistrado);
}

export function getRolesMagistrado(magistrado, processo, dominioStore, entradaAtual) {
    const dominioMag = entradaAtual || getEntradaDominioAtual(magistrado, dominioStore);

    const casa = (alvo) => {
        if (!alvo) return false;
        if (magistrado.cpf && alvo.cpf && magistrado.cpf === alvo.cpf) return true;
        if (alvo.sigla === magistrado.sigla) return true;

        return !!dominioMag && (alvo.sigla === dominioMag.sigla || alvo.sigla === dominioMag.siglaAdministrativa);
    };

    return {
        relator: casa(processo.relator),
        redator: casa(processo.redator)
    };
}

export function mesmosMagistrados(listaA, listaB) {
    const idsA = (listaA || []).map((item) => item.magistrado?.id).filter(Boolean);
    const idsB = (listaB || []).map((item) => item.magistrado?.id).filter(Boolean);

    if (idsA.length !== idsB.length) return false;

    const setB = new Set(idsB);
    return idsA.every((id) => setB.has(id));
}

const chaveIdentidadeMagistrado = (entrada) => `${entrada?.magistrado?.sigla ?? ''}|${entrada?.magistrado?.cpf ?? ''}`;

function chavesOrdenadas(composicao) {
    return composicao.map((magistrado) => chaveIdentidadeMagistrado(magistrado)).toSorted((a, b) => a.localeCompare(b));
}

export function composicoesIguais(composicaoA, composicaoB) {
    if (composicaoA === composicaoB) return true;

    if (!Array.isArray(composicaoA) || !Array.isArray(composicaoB) || composicaoA.length !== composicaoB.length) {
        return false;
    }

    const chavesB = chavesOrdenadas(composicaoB);

    return chavesOrdenadas(composicaoA).every((chave, indice) => chave === chavesB[indice]);
}

export function criarEntradaComposicao(magistrado, camposExtras = {}) {
    return {
        magistrado: {
            id: magistrado.id,
            ausente: false,
            presidenteSessao: false,
            genero: magistrado.genero,
            nome: magistrado.nome,
            sigla: magistrado.sigla,
            cpf: magistrado.cpf,
            codigoCargo: magistrado.codigoCargo,
            converterSigla: magistrado.converterSigla,
            siglaAdministrativa: magistrado.siglaAdministrativa,
            ...camposExtras
        }
    };
}

export function normalizarLinhasEmBranco(texto) {
    if (typeof texto !== 'string') return texto;
    if (texto.trim() === '') return '';

    return (
        texto
            // eslint-disable-next-line sonarjs/super-linear-regex
            .replaceAll(/(?:[ \t]*\r?\n){3,}/g, '\n\n')
            .replace(/^(?:[ \t]*\r?\n){2,}/, '\n')
            // eslint-disable-next-line sonarjs/super-linear-regex
            .replace(/(?:\r?\n[ \t]*){2,}$/, '\n')
    );
}

export function chaveMagistrado(comp, shouldIncluirSituacaoImpedimento = false) {
    const magistrado = comp.magistrado;

    const partes = [magistrado.sigla, magistrado.cpf, magistrado.presidenteSessao ? 1 : 0, magistrado.ausente ? 1 : 0];

    if (shouldIncluirSituacaoImpedimento) {
        partes.push(magistrado.situacaoImpedimento || '');
    }

    partes.push(magistrado.magistradoSubstituido?.sigla || '', magistrado.siglaSubstituto || '');

    return partes.join('|');
}

export function chaveComposicao(composicao, shouldIncluirSituacaoImpedimento = false) {
    return (composicao || [])
        .map((comp) => chaveMagistrado(comp, shouldIncluirSituacaoImpedimento))
        .toSorted((a, b) => a.localeCompare(b))
        .join(';');
}

export function removerMagistrado(novaComposicao, magistrado) {
    const indexSubstituido = novaComposicao.findIndex((comp) => comp.magistrado.siglaSubstituto === magistrado.sigla);

    if (indexSubstituido !== -1) {
        novaComposicao[indexSubstituido].magistrado.magistradoSubstituto = { sigla: '' };
        novaComposicao[indexSubstituido].magistrado.siglaSubstituto = '';
    }

    const index = novaComposicao.findIndex(
        (comp) =>
            (magistrado.cpf && comp.magistrado.cpf && comp.magistrado.cpf === magistrado.cpf) ||
            (comp.magistrado.nome === magistrado.nome && comp.magistrado.sigla === magistrado.sigla)
    );

    if (index !== -1) {
        novaComposicao.splice(index, 1);
    }

    magistrado.ausente = false;
}

export function definirPresidente(novaComposicao, magistrado) {
    for (const comp of novaComposicao) {
        comp.magistrado.presidenteSessao = false;
    }

    magistrado.presidenteSessao = true;
}

export function existePresidente(composicao) {
    return Boolean(composicao?.some((comp) => comp.magistrado.presidenteSessao));
}

export function resumoMagistrado(magistrado) {
    return {
        nome: magistrado.nome,
        sigla: magistrado.sigla,
        cpf: magistrado.cpf,
        codigoCargo: magistrado.codigoCargo,
        genero: magistrado.genero
    };
}

export function definirSubstituto(magistrado, substituto) {
    magistrado.magistradoSubstituto = {
        sigla: substituto.sigla,
        nome: substituto.nome,
        cpf: substituto.cpf,
        id: substituto.id,
        converterSigla: substituto.converterSigla
    };
    magistrado.presidenteSessao = false;
    magistrado.siglaSubstituto = substituto.sigla;
}

export function rolarParaFim(seletor) {
    setTimeout(() => {
        const elemento = document.querySelector(seletor);

        if (elemento !== null) {
            elemento.scrollTop = elemento.scrollHeight;
        }
    }, 1);
}

export function defineRedatorRelator(roles, title, magistrado) {
    if (roles.relator) {
        title = 'Relator(a) ' + magistrado.nome;
    }
    if (roles.redator) {
        title = 'Redator(a) ' + magistrado.nome;
    }
    return title;
}

export function estiloChipMagistrado(roles) {
    return roles.redator
        ? {
              minWidth: '10ch',
              height: '24px',
              color: 'black',
              fontSize: 12,
              borderWidth: '4px',
              borderStyle: 'solid',
              borderColor: '#b5b5b5'
          }
        : { minWidth: '10ch', height: '24px' };
}

export function tooltipBotaoSalvar(existePresidenteNaComposicao, composicaoFoiAlterada, atualizarCertidao) {
    if (!existePresidenteNaComposicao) {
        return 'Defina o presidente para prosseguir';
    }

    return composicaoFoiAlterada || atualizarCertidao ? '' : 'Nenhuma alteração na composição para salvar';
}

const ComposicaoUtil = {
    sortObject,
    montarNomeComTratamento,
    removerAusenciaMagistrados,
    obterDecisaoCertidao,
    getEntradaDominioAtual,
    variantePosterior,
    isMagistradoSubstitutoDefinido,
    isMagistradoSubstituidoDefinido,
    localizacaoUsuario,
    defineTitle,
    tooltipSubstituicao,
    shouldEsconderComboSubstituto,
    getRolesMagistrado,
    mesmosMagistrados,
    composicoesIguais,
    criarEntradaComposicao,
    normalizarLinhasEmBranco,
    chaveMagistrado,
    chaveComposicao,
    removerMagistrado,
    definirPresidente,
    existePresidente,
    resumoMagistrado,
    definirSubstituto,
    rolarParaFim,
    defineRedatorRelator,
    estiloChipMagistrado,
    tooltipBotaoSalvar
};

export default ComposicaoUtil;
